import React, { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { Member, Organization } from "../common/ObjectTypes";
import { BackArrow, Delete } from "../common/ProjectIcons";
import NoResults from "../common/NoResults";
import { containerClasses, tableClasses, textClasses, buttonClasses } from "../common/tailwindClassnames";

type OrganizationDetailsProps = {
    orgMembers: Member[],
    organization: Organization,
    onBackArrow: MouseEventHandler,
    onClickInvite: MouseEventHandler,
    onClickMember: Function,
    onToggleModal: MouseEventHandler,
    onToggleRemoveMemberModal: Function,
    currentMember: Member,
    superuser: boolean
}

const OrganizationDetails = ({
    orgMembers,
    organization,
    onBackArrow,
    onToggleModal,
    onClickInvite,
    onClickMember,
    onToggleRemoveMemberModal,
    currentMember,
    superuser
}: OrganizationDetailsProps) => {
    const { t } = useTranslation();
    return (
        <div className={containerClasses.page}>
            <div className="text-blue-basic dark:text-dark-blue-300 flex flex-row text-sm mb-3 cursor-pointer hover:underline w-min transition-colors duration-300"
                onClick={onBackArrow}>
                <BackArrow />  <label className="ml-2">{t("Workspaces")}</label>
            </div>
            <div className="mb-3 flex justify-between">
                <div>
                    <h1 className={textClasses.heading}>{organization.name}</h1>

                </div>
                {(currentMember.role === "admin" || superuser) && <div>
                    <button className="hover:bg-light-gray dark:hover:bg-neutral-gray-700 text-dark-green dark:text-dark-green-100 rounded px-5 py-2 mr-3 transition-colors duration-300"
                        onClick={onToggleModal}>
                        {t("Update")}
                    </button>
                    <button className={buttonClasses.primary}
                        onClick={onClickInvite}
                    >
                        {t("Add User")}
                    </button>
                </div>}
            </div>
            {orgMembers.length < 1 &&
                <NoResults
                    headerMsg={t("No Members Found")}
                    labelMsg={t("You may need to add your first member, or contact system admin.")}
                />}
            {orgMembers.length >= 1 &&
                <table className={tableClasses.container}>
                    <thead className={tableClasses.header}>
                        <tr>
                            <th className={tableClasses.headerCell}>
                                {t("Name")}
                            </th>
                            <th className={tableClasses.headerCell}>
                                {t("Email")}
                            </th>
                            {/* <th className="p-3">
                                    Last Login
                                </th> */}
                            <th className={tableClasses.headerCell}>
                                {t("Role")}
                            </th>
                            {(currentMember.role === "admin" || superuser) && <th className={tableClasses.headerCell}>
                                &nbsp;
                            </th>}
                        </tr>
                    </thead>
                    <tbody className="text-sm dark:text-white transition-colors duration-300">
                        {orgMembers.map((org_member: Member) => {
                            return (
                                <tr key={org_member.id ? org_member.id.toString() : Math.random()}
                                    className="border border-gray-lines dark:border-secondary-gray hover:bg-light-blue dark:hover:bg-neutral-gray-700 bg-white dark:bg-off-black transition-colors duration-300">
                                    <td className={tableClasses.cell}
                                        onClick={() => onClickMember(org_member.id)}>
                                        {org_member.full_name}
                                    </td>
                                    <td className={tableClasses.cell}
                                        onClick={() => onClickMember(org_member.id)}>
                                        {org_member.email}
                                    </td>
                                    {/* <td className="p-3">
                                            Non mvp
                                        </td> */}
                                    <td className={tableClasses.cell}
                                        onClick={() => onClickMember(org_member.id)}>
                                        {org_member.role}
                                    </td>
                                    {(currentMember.role === "admin" || superuser) && <td className={tableClasses.cell + " text-right"}
                                        onClick={() => onToggleRemoveMemberModal(org_member.id)}>
                                        <Delete />
                                    </td>}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>}
        </div>
    );
};

export default OrganizationDetails;